module.exports = __webpack_public_path__ + "img/g1.6e1d5b63.webp";